const permissions = {
	publisherAdmin: [
		"admin",
		"articles.view",
		"artifacts.delete",
		"costs.view",
		"distributions.admin",
		"distributions.view",
		"listPublisherProductions",
		"notifications.view",
		"offers.prepare",
		"orders.view",
		"production.masterExportCreate",
		"productionBlurbProofScript.edit",
		"productionBlurbProofScript.view",
		"productions.manage",
		"productions.settings.level1",
		"readers.view",
		"settings.view",
		"todos.view",
		"todos.pin",
		"users.manage",
		"users.view",
		"discussions.needsAttention",
	],
	// förlagsmedarbetare
	publisherStaff: [
		"articles.view",
		"distributions.view",
		"listPublisherProductions",
		"notifications.view",
		"offers.prepare",
		"production.masterExportCreate",
		"productionBlurbProofScript.edit",
		"productionBlurbProofScript.view",
		"productions.manage",
		"productions.settings.level1",
		"readers.view",
		"todos.view",
		"discussions.needsAttention",
	],
	producerAdmin: [
		"admin",
		"agreements.create",
		"agreements.delete",
		"agreements.send",
		"agreements.terminate",
		"agreements.view",
		"apps.view",
		"artifacts.delete",
		"availability.editOthers",
		"availability.editReaders",
		"billing.createInvoice",
		"calendar.defaultAllSessions",
		"calendar.defaultTimeline",
		"calendar.editAllSessions",
		"calendar.view",
		"calendar.viewTimeline",
		"costs.delete",
		"costs.view",
		"createProducerStaff",
		"distribution.editDistributors",
		"documents.create",
		"finance.editProductionPrices",
		"listProducerProductions",
		"listPublisherProductions",
		"menuOption.ProducerSettings",
		"myProductions.productionRequests",
		"notifications.view",
		"offers.prepare",
		"offers.send",
		"orders.manage",
		"orders.view",
		"organization.notifications.view",
		"organization.todos.view",
		"prices.apply",
		"prices.create",
		"prices.delete",
		"prices.view",
		"production.accept",
		"production.deleteAfterAccepted",
		"production.masterExportCreate",
		"production.masterExportEdit",
		"productionBlurbProofScript.edit",
		"productionBlurbProofScript.view",
		"productionTodos.manage",
		"productions.admin",
		"productions.artifacts",
		"productions.delete",
		"productions.deliver",
		"productions.accept",
		"productions.finalize",
		"productions.listUnacceptedProductions",
		"productions.manage",
		"productions.settings.level1",
		"productions.settings.level2",
		"productions.settings.level3",
		"productions.settings.level4",
		"productions.viewStatistics",
		"publishers.view",
		"readers.view",
		"sessions.book",
		"settings.view",
		"startPage.listAdminAlerts",
		"studioSession.connect",
		"studios.view",
		"todos.delete",
		"todos.view",
		"todos.pin",
		"users.manage",
		"users.view",
		"users.viewContactDetails",
		"whatsNew.view",
		"discussions.manage",
		"discussions.feed",
	],
	// production coordinators
	producerStaff: [
		"availability.editOthers",
		"availability.editReaders",
		"billing.createInvoice",
		"calendar.defaultTimeline",
		"calendar.editOwnSessions",
		"calendar.view",
		"calendar.viewTimeline",
		"createProducerStaff",
		"listProducerProductions",
		"offers.prepare",
		"offers.send",
		"production.masterExportCreate",
		"productionBlurbProofScript.edit",
		"productionBlurbProofScript.view",
		"productionTodos.manage",
		"productions.artifacts",
		"productions.deliver",
		"productions.accept",
		"productions.finalize",
		"productions.listUnacceptedProductions",
		"productions.manage",
		"productions.settings.level1",
		"productions.settings.level2",
		"productions.settings.level4",
		"readers.view",
		"sessions.book",
		"startPage.listAdminAlerts",
		"users.viewContactDetails",
		"whatsNew.view",
		"discussions.manage",
	],
	producerRecorder: [
		"availability.editReaders",
		"availability.standardTime",
		"calendar.view",
		"calendar.viewTimeline",
		"listProducerProductions",
		"productionBlurbProofScript.view",
		"productions.listUnacceptedProductions",
		"startPage.listProductionsMissingRecorder",
		"studioSession.connect",
	],
	producerEditor: [
		"calendar.view",
		"listProducerProductions",
		"production.masterExportCreate",
		"production.masterExportEdit",
		"productionBlurbProofScript.view",
		"startPage.listProductionsMissingEditor",
	],
	producerProofer: [
		"calendar.view",
		"listProducerProductions",
		"productionBlurbProofScript.view",
		"startPage.listProductionsMissingProofer",
	],
	producerSubcontractor: [
		"listProducerProductions",
		"productionBlurbProofScript.view",
		"productions.artifacts",
		"productions.settings.level1",
		"productions.settings.level2",
		"subcontractor",
	],
	reader: [
		"availability.bookableTime",
		"calendar.view",
		"listProducerProductions",
		"productionBlurbProofScript.view",
	],
	finance: ["finance.listPurchaseOrders"],
	super: ["super", "production.deleteAfterAccepted"],
	producerReaderManager: ["readers.view", "readerRegistry.campaign", "availability.editReaders", "documents.view"],
};

export default permissions;
